module.exports = __webpack_public_path__ + "img/feixiaohao.f06251c4.png";